import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { DropboxSendMobileComponent } from './dropbox-send-mobile.component';
import { UploadProgressComponent } from './upload-progress/upload-progress.component';


@NgModule({
  declarations: [DropboxSendMobileComponent, UploadProgressComponent],
  imports: [
    CommonModule,
    SharedModule,
  ],
  exports: [DropboxSendMobileComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class DropboxSendMobileModule { }
